import React, { useRef, useEffect, useState } from "react"
import styles from "../../styles/signup.module.scss"
import Form from "./Form"
import formStyles from "../../styles/form.module.scss"
import successImg from "../../images/signup-success.png"
import Sizing from "./Sizing"
import Share from "./Share"

const Signup = ({ color }) => {
    const [success, setSuccess] = useState(false)
    const [hide, setHide] = useState(false)

    const colors = [].concat(color)

    if (colors.length == 1) {
        colors.unshift("#262626")
    }

    const triggerSuccess = () => {
        setSuccess(true)

        setTimeout(() => {
            setHide(true)
        }, 1000)
    }

    return (
        <>
            <div className={styles.main}>
                <Share type="signup" />

                <div className={styles.bottom} style={{ "--color": colors[0] }}>
                    <div
                        className={styles.middle}
                        style={{ "--color": colors[1] }}
                    >
                        <div className={styles.top}>
                            <div
                                className={`${styles.content}  ${
                                    success ? styles.fadeout : ""
                                } ${hide ? styles.hide : ""}`}
                            >
                                <span className={styles.heading + " h4"}>
                                    Sign up for alerts and updates from Free
                                    Markets Destroy.
                                </span>
                                <span className={styles.copy}>
                                    To receive further articles of interest,
                                    event information, news updates and
                                    communications, simply complete the field
                                    below to subscribe.
                                </span>

                                <Form
                                    styles={formStyles}
                                    triggerSuccess={triggerSuccess}
                                ></Form>
                            </div>

                            <div
                                className={`${styles.success} ${
                                    success ? styles.show : ""
                                } ${hide ? styles.fadein : ""}`}
                            >
                                <img src={successImg} alt="" />
                                <span className={styles.heading + " h4"}>
                                    Thank you for subscribing to Free Markets
                                    Destroy.
                                </span>
                                <span className={styles.copy}>
                                    You’ll hear from us soon.
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Signup
